import React, { Component } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";

export default class Loader extends Component {
  render() {
    const { loader } = this.props;
    return (
      <Dialog
        open={loader.open}
        aria-labelledby="Loading..."
        PaperProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0,0)",
            boxShadow: "0px 0px 0px rgba(0, 0, 0,0)",
          },
        }}
      >
        <DialogTitle>
          <CircularProgress size={75} sx={{ color: "#031634" }} />
        </DialogTitle>
      </Dialog>
    );
  }
}
